import { render, staticRenderFns } from "./ManageTimeSlots.vue?vue&type=template&id=2ece0baa&"
import script from "./ManageTimeSlots.vue?vue&type=script&lang=ts&"
export * from "./ManageTimeSlots.vue?vue&type=script&lang=ts&"
import style0 from "./ManageTimeSlots.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports